
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M16 24.988l.11.007a.875.875 0 11-.22 0l.11-.007zm6.066-12.772a6.13 6.13 0 01-4.751 6.875 1.01 1.01 0 00-.807.855l-.008.116v1.67a.5.5 0 01-.992.09l-.008-.09v-1.676a2.01 2.01 0 011.45-1.906l.16-.038a5.128 5.128 0 10-6.235-5 .5.5 0 11-1 .002 6.128 6.128 0 0112.191-.898z"}})])
          )
        }
      }
    